<template>
    <div class="empty">
        <img :src="EmptyImg"/>
        <p>{{ $t('subscribe_plan.input_sim.no_sim') }}</p>
        <ReoLink
            :text="$t('subscribe_plan.input_sim.support_link')"
            :href="config.no_sim_support"
        />
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import EmptyImg from 'IMAGE/dashboard/Empty.svg';
import { config } from 'CONFIG';
import ReoLink from '@/basic/Link.vue';

export default Vue.extend({
    name: 'NoSim',
    components: {
        ReoLink
    },
    data() {

        return {
            EmptyImg,
            config
        };

    }
});
</script>

<style lang="less" scoped>
.empty {
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    padding-top: 77px;
    padding-bottom: 70px;

    @media @mobile {
        gap: 4px;
        padding-top: 0;
        padding-bottom: 12px;
    }

    p {
        font-size: 24px;
        font-weight: 500;

        @media @mobile {
            font-size: 16px;
        }
    }

    /deep/ .ui-link {
        .text {
            font-size: 20px;

            @media @mobile {
                font-size: 14px;
            }
        }
    }

    img {
        margin-bottom: 16px;

        @media @mobile {
            margin-bottom: 0;
            width: 200px;
        }
    }
}
</style>
